import { useState } from "react";
import classNames from "classnames";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "shared/components/common/customButton";
import CustomInput from "shared/components/common/customInput";
import { toastMessage } from "shared/components/common/toast";
import { updateUserName } from "shared/redux/reducers/authSlice";
import { UpdateProfileService } from "shared/services/settings";
import * as Yup from "yup";
import styles from "./style.module.scss";

const UpdateProfile = () => {
  const { auth } = useSelector((state: any) => state.root);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);

  const validationSchema = Yup.object({
    fullname: Yup.string().required("Name is required"),
  });

  const formik = useFormik({
    initialValues: {
      fullname: auth?.user?.fullname ?? "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        await UpdateProfileService(values.fullname);
        toastMessage("success", "Profile updated successfully");
        dispatch(updateUserName(values.fullname));
      } catch (error) {
        toastMessage("error", "Failed to update profile. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div>
      <h1 className="font-medium">Update Profile</h1>
      <div className={classNames(styles.sectionContainer, "my-4")}>
        <form
          onSubmit={formik.handleSubmit}
          className={classNames(styles.body)}
        >
          <div>
            <CustomInput
              label="Name"
              placeholder="Enter Name"
              name="fullname"
              value={formik.values.fullname}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.fullname && formik.errors.fullname
                  ? formik.errors.fullname
                  : ""
              }
            />
          </div>

          <div className="flex justify-end mt-3">
            <CustomButton type="submit" title="Update" loading={loading} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateProfile;
